import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {TalentLinkComponent} from './talent-link/talent-link.component';
import {TalentProfileComponent} from './talent-profile/talent-profile.component';
import {TalentProfilePageComponent} from './talent-profile-page/talent-profile-page.component';
import {TalentSummaryComponent} from './talent-summary/talent-summary.component';
import {SubmittalFeedbackComponent} from './feedback/submittal-feedback.component';
import {RatesPipe} from './rates.pipe';
import {DaysAgoPipe} from './days-ago.pipe';
import {ProfileApiService} from './profile-api.service';
import {SubmittalFeedbackService} from './submittal-feedback.service';

const PIPES = [
  DaysAgoPipe,
  RatesPipe
];

/**
 * Provides basic talent/submittal profile endpoints.
 */
@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    TalentLinkComponent,
    TalentProfileComponent,
    TalentProfilePageComponent,
    TalentSummaryComponent,
    SubmittalFeedbackComponent,
    ...PIPES
  ],
  providers: [
    ProfileApiService,
    SubmittalFeedbackService
  ],
  entryComponents: [
    TalentProfilePageComponent
  ],
  exports: [
    TalentProfileComponent,
    TalentSummaryComponent,
    ...PIPES
  ]
})
export class ProfileModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ProfileModule,
      providers: [
        ...PIPES
      ]
    };
  }
}
